import { FadeUp } from './Reveal';

export const Founder = ({ person: p, flip }) => (
  <article data-testid={`founder-${p.id}`} className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
    <FadeUp className={`lg:col-span-5 ${flip ? 'lg:order-2' : ''}`}>
      <div className="relative lg:sticky lg:top-28">
        <img
          src={p.image}
          alt={`${p.first} ${p.last.replace('.', '')} — ${p.role}`}
          className="w-full aspect-square object-cover rounded-[2rem] border border-cream/15"
        />
        <span className="absolute top-5 left-5 bg-butter text-ink text-[11px] font-bold uppercase tracking-[0.15em] px-3 py-1.5 border border-ink">
          {p.num} — {p.role}
        </span>
      </div>
    </FadeUp>

    <div className={`lg:col-span-7 ${flip ? 'lg:order-1' : ''}`}>
      <FadeUp>
        <p className="text-[11px] uppercase tracking-[0.3em] text-butter font-bold mb-5">{p.tagline}</p>
        <h2 className="font-slab font-black text-5xl sm:text-6xl lg:text-7xl leading-[0.98] tracking-tight">
          {p.first}<br /><span className="text-butter">{p.last}</span>
        </h2>
      </FadeUp>
      <FadeUp delay={0.1} className="mt-10 space-y-5 text-cream/80 text-base sm:text-lg leading-relaxed">
        {p.paras.map((t) => <p key={t.slice(0, 24)}>{t}</p>)}
      </FadeUp>
      <FadeUp delay={0.1} className="my-10">
        <blockquote className="relative border-l-4 border-butter pl-6 sm:pl-8 py-2">
          <p className="font-slab font-bold text-2xl sm:text-3xl leading-snug">{p.statement ? p.quote : `“${p.quote}”`}</p>
        </blockquote>
      </FadeUp>
      <FadeUp delay={0.1} className="space-y-5 text-cream/80 text-base sm:text-lg leading-relaxed">
        {p.paras2.map((t) => <p key={t.slice(0, 24)}>{t}</p>)}
      </FadeUp>
      <FadeUp delay={0.1} className="mt-10">
        <div className="bg-butter text-ink border border-ink rounded-xl px-6 py-5 font-slab font-bold text-base sm:text-lg">{p.today}</div>
      </FadeUp>
    </div>
  </article>
);
